// create a pie chart map component
import { Flex, Grid, GridItem } from '@chakra-ui/react';
import { StatusPieChart } from 'screens/Team/Rabbit/Goals/AgGridTreeView/components/CommonTreeCell/StatusPieChart';

import { TextLabel } from 'uiToolkitV1/Typography';

const PieChartMap = ({ chartData }) => (
  <Flex flexDir="column">
    <Flex alignItems="center">
      <Flex alignItems="center" justifyContent="center" h="80px" w="80px">
        <StatusPieChart data={chartData} />
      </Flex>
      <Flex direction="column" ml="4px">
        <Grid templateColumns="repeat(4, 1fr)">
          {chartData.map(({ label, value, color }) => (
            <>
              <GridItem colSpan={3}>
                <TextLabel key={label} color={color}>{`${label} : `}</TextLabel>
              </GridItem>
              <GridItem colSpan={1}>
                <TextLabel key={value} color={color} textAlign="right">
                  {value}
                </TextLabel>
              </GridItem>
            </>
          ))}
        </Grid>
      </Flex>
    </Flex>
  </Flex>
);

export { PieChartMap };
